import type { Product } from 'state/secondaryMarket/cpOrder/referential/product/product.model';
import type { OtcClient } from 'state/secondaryMarket/shared/referential/referential.model';
import type { AppState } from 'state/state.model';

function getBookingParams(state: AppState, tabId: string) {
  return getProduct(state, tabId)?.dominoProduct;
}
function getProduct(state: AppState, tabId: string): Product | undefined {
  return state.secondaryMarket.cpOrder.referential.product[tabId];
}

function getBookingParamsCutOff(state: AppState, tabId: string) {
  return getBookingParams(state, tabId)?.cutOff;
}

export function getBookingParamsCutoffLimitTime(state: AppState, tabId: string) {
  const cutoff = getBookingParamsCutOff(state, tabId);
  return cutoff?.limitTime;
}

export function getOtcDealPositions(state: AppState, tabId: string) {
  const params = getBookingParams(state, tabId);
  return params?.otcDealPositions;
}

export function getBookingParamsCutoffZoneId(state: AppState, tabId: string) {
  const cutoff = getBookingParamsCutOff(state, tabId);
  return cutoff?.zoneId;
}

export function getBookingParamsCutoffNextCutOff(state: AppState, tabId: string) {
  const cutoff = getBookingParamsCutOff(state, tabId);
  return cutoff?.nextCutOff;
}

export function getBookingParamsAvailableValuationDates(state: AppState, tabId: string) {
  return getBookingParams(state, tabId)?.valuationDates;
}

export function getBookingParamsSettlementHolidays(state: AppState, tabId: string) {
  const bookingParams = getBookingParams(state, tabId);
  return bookingParams?.settlementHolidays;
}

export function getBookingParamsValuationDates(state: AppState, tabId: string) {
  const bookingParams = getBookingParams(state, tabId);
  return bookingParams?.valuationDates;
}

export function getBookingParamsOtcDealPositions(state: AppState, tabId: string) {
  const bookingParams = getBookingParams(state, tabId);
  return bookingParams?.otcDealPositions;
}

export function getErrorMessages(state: AppState, tabId: string) {
  return getProduct(state, tabId)?.errors ?? [];
}

export function getWarningMessages(state: AppState, tabId: string) {
  return getProduct(state, tabId)?.warnings ?? [];
}

export function getInfoMessages(state: AppState, tabId: string) {
  return getProduct(state, tabId)?.infos ?? [];
}

export function getBookingParamsOtcDealPositionFromEliotCode(
  state: AppState,
  tabId: string,
  clientEliotCode: string | undefined,
): OtcClient | undefined {
  const bookingParams = getBookingParams(state, tabId);
  return bookingParams?.otcDealPositions?.find(x => x.eliotCode === clientEliotCode);
}
